const normalizeStyle = (value = '') => (
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
);

const MAP_REVEAL_STYLE_MAP = {
  folded_map: 'memory-map',
  folded_map_reveal: 'memory-map',
  campus_map: 'campus-map',
  venue_route: 'venue-route',
};

const MUSEUM_REVEAL_STYLE_MAP = {
  glass_case: 'gallery-case',
  archive_shelf: 'archive-shelf',
};

const BLESSING_REVEAL_STYLE_MAP = {
  note_cards: 'note-cards',
  guest_card: 'guest-card',
  sticky_notes: 'sticky-notes',
};

export const getMapStyle = (themeId, revealStyle = '') => {
  if (MAP_REVEAL_STYLE_MAP[revealStyle]) return MAP_REVEAL_STYLE_MAP[revealStyle];
  if (themeId === 'wedding_favor') return 'venue-route';
  if (themeId === 'friends_graduation') return 'campus-map';
  return 'memory-map';
};

export const getMuseumStyle = (themeId, revealStyle = '') => {
  if (MUSEUM_REVEAL_STYLE_MAP[revealStyle]) return MUSEUM_REVEAL_STYLE_MAP[revealStyle];
  if (themeId === 'quiet_keepsake' || themeId === 'pet_memorial' || themeId === 'memorial_legacy' || themeId === 'remembrance') {
    return 'archive-shelf';
  }
  return 'gallery-case';
};

export const getBlessingStyle = (themeId, revealStyle = '') => {
  if (BLESSING_REVEAL_STYLE_MAP[revealStyle]) return BLESSING_REVEAL_STYLE_MAP[revealStyle];
  if (themeId === 'wedding_favor') return 'guest-card';
  if (themeId === 'friends_graduation') return 'sticky-notes';
  return 'note-cards';
};

export const getRevealStyleClass = (revealStyle = '') => normalizeStyle(revealStyle);
